<template>
    <div>
        <span class="colors" style="color:#fe465d">qqqq<slot></slot>ee</span>
    </div>
</template>

<script>
export default {
    name:'YButton',
    data () {
        return {
            name:''
        };
    },
    mounted() {},
    methods: {},
    components: {}
}
</script>
<style  scoped>
.colors{
    font-size: 30px;
}
</style>